/**
 * Cadrage storefront In-App — helpers Admin (miroir backend).
 */

export const DEFAULT_STOREFRONT_OBJECT_POSITION = Object.freeze({ x: 42, y: 40 });

function clampPercent(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return Math.min(100, Math.max(0, n));
}

export function sanitizeStorefrontObjectPosition(raw) {
  if (raw == null || typeof raw !== 'object') {
    return { ...DEFAULT_STOREFRONT_OBJECT_POSITION };
  }
  const x = clampPercent(raw.x);
  const y = clampPercent(raw.y);
  if (x == null || y == null) {
    return { ...DEFAULT_STOREFRONT_OBJECT_POSITION };
  }
  return { x, y };
}

export function resolveStorefrontObjectPositionFromMeta(meta) {
  const m = meta && typeof meta === 'object' ? meta : {};
  return sanitizeStorefrontObjectPosition(m.storefrontObjectPosition);
}

export function isDefaultStorefrontObjectPosition(pos) {
  const p = sanitizeStorefrontObjectPosition(pos);
  return (
    p.x === DEFAULT_STOREFRONT_OBJECT_POSITION.x &&
    p.y === DEFAULT_STOREFRONT_OBJECT_POSITION.y
  );
}
